<template>
  <b-card class="animated fadeIn">
    <b-row>
      <b-col lg="12" class="section">
        <VBrandLimitOfferEditList
          :searchResults="availableOffers"
          :selectedOffers="selectedOffers"
          :busy="isBusy">
        </VBrandLimitOfferEditList>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import { mapGetters, mapState } from "vuex";
  import { OFFER_SEARCH } from "@/store/offer/actions.type";
  import VBrandLimitOfferEditList from "@/components/VBrandLimitOfferEditList";

  export default {
    name: "VBrandLimitOfferEdit",
    components: {
      VBrandLimitOfferEditList
    },
    data() {
      return {
        criteria: {},
        sortBy: "copay_offer_name",
        sortDesc: false,
        availableOffers: []
      };
    },
    props: {
      selectedOffers: {
        required: false,
        type: Array
      }
    },
    computed: {
      ...mapGetters({
        groups: "groups"
      }),
      ...mapState({
        searchResults: state => state.offer.searchResults,
        isBusy: state => state.offer.isBusy
      })
    },
    beforeMount() {
      this.$store.dispatch(OFFER_SEARCH).then(result => {
        const now = new Date().toISOString();
        this.availableOffers = this.searchResults.results.filter(item => {
          if (now < item.current_offer_end_date) {
            return item;
          }
        });
      });
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/VBrandLimitOfferEdit.vue